import React, { useEffect } from 'react';
import moment from 'moment';
import { inject, observer } from 'mobx-react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Grid, Paper, Typography } from '@material-ui/core';
import { CustomTextBox } from '../components/common';
import GuideMessageM from '../components/message/GuideMessageM';
import { CustomButton } from '../components/button';
import { TrackingDetail } from '../components/tracking';
import { openKakaoChannel } from '../components/chat/chatLinks';

// 배송조회 — 진행 중인 접수. 기업회원은 카드 위에 추적 상세(단계·남은 거리·시간)가 붙고 30초마다 새로 읽는다
const REFRESH_MS = 30 * 1000;

const useStyles = makeStyles(() => ({
  title: { marginBottom: 60 },
  inputBox: {
    maxWidth: 500,
    padding: '0 30px',
    marginBottom: 30,
  },
  noMsg: {
    width: '100%',
    padding: '20px 0',
    textAlign: 'center',
    borderRadius: 10,
  },
}));

const orderType = { Move: '이사', Freight: '화물', Quick: '퀵 서비스' };

function DeliveryTrackingPage({ myPageStore, loginStore }) {
  const cs = useStyles();
  const { deliverySel, delivery } = myPageStore;
  const { userInfo } = loginStore;
  const corporate = Boolean(userInfo && userInfo.userType === 'Company');

  useEffect(() => {
    deliverySel();
    if (!corporate) return undefined;
    const timer = window.setInterval(() => { if (document.visibilityState === 'visible') deliverySel(); }, REFRESH_MS);
    return () => window.clearInterval(timer);
  }, [deliverySel, corporate]);

  return (
    <Grid className="mainLayout" container direction="column" justify="center" alignItems="center">
      <Grid item className={cs.title}>
        <GuideMessageM title="배송조회" resultTitle="배송조회" subTitle="진행 중인 서비스를 조회합니다." />
      </Grid>
      <Grid className={cs.inputBox} container direction="column" justify="center" alignItems="flex-start">
        {!delivery.length && (
          <Paper className={cs.noMsg} elevation={0}>
            <Typography variant="body2" color="primary">진행 중인 서비스가 없습니다.</Typography>
          </Paper>
        )}
        {delivery.map((item) => (
          <div style={{ width: '100%' }} key={item.orderKey || item.orderNumber}>
            {item.tracking && <TrackingDetail tracking={item.tracking} />}
            <Box height={15} />
            <CustomTextBox title="오더번호" subTitle={item.serialNumber || '접수 처리중'} />
            <Box height={15} />
            <CustomTextBox title="배송상태" subTitle={item.state || '접수 완료'} />
            <Box height={15} />
            <CustomTextBox title="서비스 구분" subTitle={orderType[item.orderType]} />
            <Box height={15} />
            <CustomTextBox title="요청시간" subTitle={moment(item.createdDate).format('YYYY-MM-DD HH:mm')} />
            <Box height={15} />
            <CustomTextBox title="출발" subTitle={item.startAddr} />
            <Box height={15} />
            <CustomTextBox title="도착" subTitle={item.endAddr} />
            <Box height={25} />
            <CustomButton variant="contained" fullWidth color="primary" onClick={openKakaoChannel}>상담하기</CustomButton>
            <Box height={50} />
          </div>
        ))}
      </Grid>
    </Grid>
  );
}

export default inject('myPageStore', 'loginStore')(observer(DeliveryTrackingPage));
